// Queries the org's locations and maps them to LocationOption for the import's location resolver.

import { useMemo } from 'react';
import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';
import { formatLocationName } from '~/utils';
import type { LocationOption } from '~/pages/inventory-import/lib/locationCatalog';

const InventoryImportLocationsQuery = graphql(`
  query InventoryImportLocations {
    locations {
      id
      code
      name
      facility {
        address {
          addressLine1
          city
          region
        }
      }
    }
  }
`);

export function useLocations() {
  const { data, isLoading, error } = useGraphqlQuery(
    InventoryImportLocationsQuery,
    ['inventory-import-locations']
  );

  const locations = useMemo<LocationOption[]>(
    () =>
      (data?.locations ?? []).map((l) => ({
        id: l.id,
        code: l.code,
        name: l.name,
        displayName: formatLocationName(l),
      })),
    [data]
  );

  return { locations, isLoading, error };
}
